import { render } from "./Merchants.vue?vue&type=template&id=4d2cac68"
import script from "./Merchants.vue?vue&type=script&lang=js"
export * from "./Merchants.vue?vue&type=script&lang=js"

import "./Merchants.vue?vue&type=style&index=0&id=4d2cac68&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__